import React, { useEffect, useState } from "react";
import Input from "../../components/inputs/Input";
import Button from "../../components/btn/Button";
import "./login.css";
import logoicon from "../../assets/logo512.png";
import newLogo from "../../assets/newLogo.png";
import logotxt from "../../assets/mylpgtxt.png";
import { BiLogIn } from "react-icons/bi";
import AuthBg from "../../components/authbg/AuthBg";
import { useLocation, useNavigate, useRoutes } from "react-router-dom";
import { base_url } from "../../utils/utils";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";
import useRedirectIfAuthenticated from "../../utils/Hook/useRedirectIfAuthenticated";

const EmployeeLogin = () => {
  const [userData, setUserData] = useState({});
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const location = useLocation();
  const onLogin = async () => {
    if (
      !userData.a_id ||
      userData?.a_id?.trim().length == 0 ||
      userData?.a_id?.trim()?.length < 6 ||
      !userData.id ||
      userData?.id?.trim().length == 0 ||
      userData?.id?.trim()?.length < 6 ||
      !userData.pass ||
      userData.pass.trim().length == 0 ||
      userData.pass?.trim()?.length < 8
    ) {
      setUserData({
        ...userData,
        a_idmess:
          !userData.a_id || userData?.a_id?.trim().length == 0
            ? "Agency ID is required"
            : userData?.a_id?.length < 6
            ? "Agency ID must Contain 6 digit"
            : "",
        a_idval:
          !userData.a_id || userData?.a_id?.trim().length == 0 ? true : false,
        idmess:
          !userData.id || userData?.id?.trim().length == 0
            ? "Employee ID is required"
            : userData?.id?.length < 6
            ? "Employee ID must Contain 6 digit"
            : "",
        idval: !userData.id || userData?.id?.trim().length == 0 ? true : false,
        passmess:
          !userData.pass || userData.pass.trim().length == 0
            ? "Password is required"
            : userData.pass?.trim()?.length < 8
            ? "Password must be min 8 charector"
            : "",
        passval:
          !userData.pas || userData.pass.trim().length == 0 ? true : false,
      });
      return;
    }
    setLoading(true);
    // employee(agencyid,empid,password)
    const body = new FormData();
    body.append("action", "employee");
    body.append("agencyid", userData.a_id);
    body.append("empid", userData.id);
    body.append("password", userData.pass);
    const responce = await fetch(base_url + "agency.php", {
      method: "POST",
      body: body,
    });
    const res = await responce.json();
    setLoading(false);
    if (res.success) {
      // toast.success(res.message);
      // localStorage.setItem("userId", JSON.stringify(res));
      // navigate("/MasterData/StatutoryMaster");
      toast.success(res.message);
      localStorage.setItem("userId", JSON.stringify(res));
      if (res?.FY_STATUS !== undefined) {
        localStorage.setItem("FY_STATUS", String(res.FY_STATUS));
      }
      localStorage.setItem("IS_FTL", String(res.IS_FTL));
      localStorage.setItem("eff_date", res.date);
      navigate("/Home");
      // login()

      // store.dispatch(get_profile_img_url(res?.image_url));
      // store.dispatch(get_profile_name(res?.Name));
      // store.dispatch(get_profile_pin(res?.PIN));
    } else {
      toast.error(res.message);
    }
  };
  // const uid = localStorage.getItem("userId");
  // const ID = JSON.parse(uid);

  useRedirectIfAuthenticated();

  return (
    <AuthBg>
      {loading && <Loader loading={loading} />}
      <div className="login-inner-div">
        <div className="sidebar-logo aic jcc ">
          <img src={newLogo} className="s_logo" />
          <img src={logotxt} className="s_logotxt" />
        </div>
        <div className="login-text mt10"> Employee Log in </div>

        <Input
          label={"Agency Id"}
          placeholder={"Enter Agency Id"}
          value={userData.a_id}
          onChange={(e) => {
            const input = e.target.value
              .toUpperCase()
              .replace(/[^a-zA-Z0-9]/g, "");
            if (e.target.value.length <= 10) {
              setUserData({
                ...userData,
                a_id: input,
                a_idmess: "",
                a_idval: false,
              });
            }
          }}
          error={userData.a_idmess}
          bcolor={userData.a_idval}
        />
        <Input
          label={"Employee ID"}
          placeholder={"Enter Employee ID"}
          value={userData.id}
          onChange={(e) => {
            if (e.target.value.length <= 10) {
              setUserData({
                ...userData,
                id: e.target.value,
                idmess: "",
                idval: false,
              });
            }
          }}
          error={userData.idmess}
          bcolor={userData.idval}
        />
        <Input
          label={"Password"}
          type={showPass ? "text" : "password"}
          placeholder={"Enter Password"}
          value={userData.pass}
          onChange={(e) =>
            setUserData({
              ...userData,
              pass: e.target.value,
              passmess: "",
              passval: false,
            })
          }
          error={userData.passmess}
          bcolor={userData.passval}
          pass={true}
          setShowPass={setShowPass}
          showPass={showPass}
        />
        <div
          style={{
            width: "100%",
            marginTop: "1rem",
            display: "flex",
            justifyContent: "flex-end",
            marginRight: "1rem",
            fontSize: "14px",
            cursor: "pointer",
          }}
          onClick={() => navigate("/forgot", { state: "employee" })}
        >
          Forgot Your Password?
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "20px",
          }}
        >
          <Button
            title={"Login"}
            icon={<BiLogIn size={20} />}
            onClick={onLogin}
          />
        </div>
        <div
          style={{
            justifyContent: "center",
            marginTop: 10,
            display: "flex",
            gap: 5,
          }}
          onClick={() => navigate("/login")}
        >
          <div style={{ fontSize: 14, color: "#6f6f6f", fontWeight: "500" }}>
            Login As a
          </div>
          <div
            style={{
              cursor: "pointer",
              fontSize: 15,
              color: "#6f6f6f",
              fontWeight: "500",
            }}
          >
            Admin
          </div>
        </div>
      </div>
    </AuthBg>
  );
};

export default EmployeeLogin;
